<div class="modal-header">
    <h2 mat-dialog-title trans>Add Existing Links to Group</h2>
    <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content>
    <div class="input-container">
        <input type="text" placeholder="Search for links..." [formControl]="searchControl">
        <mat-progress-bar mode="indeterminate" color="accent" *ngIf="loading$ | async"></mat-progress-bar>
    </div>

    <div class="links" *ngIf="links$ | async as links">
        <div class="link" *ngFor="let link of links" (click)="confirm(link)">
            <img [src]="link.long_url | favicon">
            <button class="meta overflow-hidden no-style" [disabled]="loading$ | async">
                <span class="long-url overflow-hidden">{{link.long_url}}</span>
                <span class="short-url overflow-hidden">{{link.short_url}}</span>
            </button>
        </div>
        <div class="link" *ngIf="!links.length">
            <no-results-message>
                <span secondary-text trans>Could not find any links matching this query.</span>
            </no-results-message>
        </div>
    </div>
</mat-dialog-content>
